import { FilesUploader, Media } from "components";
import { MediaDirectoryKeys } from "constants/enums";
import { t } from "i18next";
import { Controller, useForm } from "react-hook-form";
import { DateInput, FormField, Input, MediaFilePicker, TimeInput } from "ui";

import {
  AnnouncementFormProps,
  AnnouncementFormValues
} from "./AnnouncementForm.types";

import styles from "./AnnouncementForm.module.scss";

const AnnouncementForm = ({
  formId,
  defaultValues,
  isEdit,
  onSubmit
}: AnnouncementFormProps) => {
  const {
    register,
    control,
    handleSubmit,
    formState: { errors }
  } = useForm<AnnouncementFormValues>({
    defaultValues
  });

  return (
    <form id={formId} className={styles.form} onSubmit={handleSubmit(onSubmit)}>
      <Input
        {...register("title")}
        errorMessage={errors.title?.message}
        label={t("Title")}
        placeholder={t("Enter Title")}
        disabled={isEdit}
      />

      <div className={styles.form_twoColumnsBlock}>
        <Controller
          control={control}
          name="shownToResellersUntilDate"
          render={({
            field: { value, onChange },
            fieldState: { error: _error }
          }) => (
            <DateInput
              label="Show until date"
              value={value}
              onChange={onChange}
            />
          )}
        />

        <Controller
          control={control}
          name="shownToResellersUntilTime"
          render={({
            field: { value, onChange },
            fieldState: { error: _error }
          }) => (
            <TimeInput
              label="Show until time"
              value={value}
              onChange={onChange}
            />
          )}
        />
      </div>

      <Controller
        control={control}
        name="image"
        render={({ field: { value, onChange }, fieldState: { error } }) => (
          <FormField
            label={t(`Announcement media`)}
            errorMessage={error?.message}
          >
            {!isEdit ? (
              <FilesUploader
                onSuccessUploading={onChange}
                uploadDirectoryKey={MediaDirectoryKeys.Announcement}
              >
                {(uploaderProps) => (
                  <MediaFilePicker
                    {...uploaderProps}
                    value={value}
                    customSize={{ width: 360, height: 200 }}
                    label={"360:200"}
                    onDeleteMediaFile={() => onChange(null)}
                    mediaClassName={styles.form_media}
                  />
                )}
              </FilesUploader>
            ) : value ? (
              <Media
                mediaFile={value}
                className={styles.form_mediaThumb}
                mediaClassName={styles.form_media}
              />
            ) : null}
          </FormField>
        )}
      />

      <Input
        {...register("text")}
        errorMessage={errors.text?.message}
        label={t("Text")}
        placeholder={t("Enter Text")}
        asTag="textarea"
        disabled={isEdit}
      />
    </form>
  );
};

export default AnnouncementForm;
